import * as actions from "../actions/AdminAbstractActions";
import { AdminAbstractState, initialState } from "../store/AdminAbstractState";
import buildReducer from "../utils/ReducerBuilder";

export const AdminAbstractReducer = buildReducer<AdminAbstractState>(initialState)
    .handle(actions.onAbstractsUpdated, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            abstracts: action.payload,
        };
    })
    .handle(actions.onEventsUpdated, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            events: action.payload,
        };
    })
    .handle(actions.onFDsUpdated, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            FDs: action.payload,
        };
    })
    .handle(actions.onGroupsUpdated, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            groups: action.payload,
        };
    })
    .handle(actions.onListAbstractsUpdated, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            listAbstracts: action.payload,
        };
    })
    .handle(actions.onTypesUpdated, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            types: action.payload,
        };
    })
    .handle(actions.toggleLoadingAbstract, (state, action) => {
        if (action.payload === undefined)
            return state;

        const loadingAbstract = { ...state.loadingAbstract };
        loadingAbstract[action.payload.abstractId] = action.payload.loading;

        return {
            ...state,
            loadingAbstract,
        };
    })
    .handle(actions.toggleLoadingEvent, (state, action) => {
        if (action.payload === undefined)
            return state;

        const loadingEvent = { ...state.loadingEvent };
        loadingEvent[action.payload.eventId] = action.payload.loading;

        return {
            ...state,
            loadingEvent,
        };
    })
    .handle(actions.toggleLoadingFDs, (state, action) => ({
            ...state,
            loadingFDs: action.payload || false,
        }))
    .handle(actions.toggleLoadingGroup, (state, action) => {
        if (action.payload === undefined)
            return state;

        const loadingGroup = { ...state.loadingGroup };
        loadingGroup[action.payload.groupId] = action.payload.loading;

        return {
            ...state,
            loadingGroup,
        };
    })
    .handle(actions.toggleLoadingGroups, (state, action) => {
        if (action.payload === undefined)
            return state;

        const loadingGroups = { ...state.loadingGroups };
        loadingGroups[action.payload.eventId] = action.payload.loading;

        return {
            ...state,
            loadingGroups,
        };
    })
    .handle(actions.toggleLoadingListAbstracts, (state, action) => ({
            ...state,
            loadingListAbstracts: action.payload || false,
    }))
    .handle(actions.toggleLoadingType, (state, action) => {
        if (action.payload === undefined)
            return state;

        const loadingType = { ...state.loadingType };
        loadingType[action.payload.typeId] = action.payload.loading;

        return {
            ...state,
            loadingType,
        };
    })
    .handle(actions.toggleLoadingTypes, (state, action) => ({
            ...state,
            loadingTypes: action.payload || false,
    }))
    .done();



// WEBPACK FOOTER //
// ./src/reducers/AdminAbstractReducer.ts